import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast"; // Quitamos Toaster de aquí, ya está en App.js
import { UserPlus, Save } from "lucide-react";

export default function CargaCliente() {
  const [cliente, setCliente] = useState({
    nombre: "",
    domicilio: "",
    telefono: "",
    localidad: "",
    descripcion_ordeniadora: "",
  });

  // Agregamos un estado de carga local para el botón
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setCliente({ ...cliente, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Si ya se está enviando, no hacemos nada
    if (isSubmitting) return;

    setIsSubmitting(true);

    // Guardamos la promesa en una constante
    const promise = axios.post(`${process.env.REACT_APP_BASE_URL}/cliente`, cliente);

    // 🚀 Implementación de toast.promise
    // Esto maneja automáticamente los 3 estados: cargando, éxito y error.
    toast.promise(
      promise,
      {
        loading: 'Registrando cliente en el sistema...',
        success: (res) => {
          setIsSubmitting(false); // Liberamos el botón
          setCliente({
            nombre: "",
            domicilio: "",
            telefono: "",
            localidad: "",
            descripcion_ordeniadora: "",
          });
          return "¡Cliente guardado con éxito!";
        },
        error: (err) => {
          setIsSubmitting(false); // Liberamos el botón
          const errorMsg = err.response?.data?.message || "Error al conectar con el servidor";
          return <b>{errorMsg}</b>;
        },
      },
      {
        success: {
          duration: 2000,
        },
      }
    );
  };

  // 🎨 Estilos de la interfaz (solo visual)
  const labelCls = "block text-[11px] font-bold text-slate-600 uppercase tracking-wide mb-1";
  const inputCls = "w-full h-9 border border-slate-300 rounded-lg px-3 text-[13px] text-slate-900 bg-white outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all";

  return (
    <div className="min-h-full flex justify-center items-start md:items-center py-2">

      <div className="bg-white shadow-sm rounded-xl w-full max-w-3xl border border-slate-200 overflow-hidden">
        {/* Header */}
        <div className="bg-slate-900 text-white px-5 py-2.5 flex items-center gap-3">
          <UserPlus size={18} />
          <div>
            <h3 className="text-[14px] font-bold uppercase tracking-tight leading-tight">Nuevo Cliente</h3>
            <p className="text-[10px] text-slate-400 font-medium">Los campos con * son obligatorios</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-4 lg:p-5">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">

            {/* Nombre */}
            <div className="md:col-span-3">
              <label className={labelCls}>Nombre / Razón Social <span className="text-red-500">*</span></label>
              <input
                type="text"
                name="nombre"
                autoComplete="off"
                value={cliente.nombre}
                onChange={handleChange}
                className={inputCls}
                placeholder="Ej: Establecimiento El Trébol"
                required
              />
            </div>

            {/* Domicilio, Localidad y Teléfono */}
            <div>
              <label className={labelCls}>Domicilio</label>
              <input
                type="text"
                name="domicilio"
                autoComplete="off"
                value={cliente.domicilio}
                onChange={handleChange}
                className={inputCls}
                placeholder="Calle o Ruta"
              />
            </div>

            <div>
              <label className={labelCls}>Localidad</label>
              <input
                type="text"
                name="localidad"
                autoComplete="off"
                value={cliente.localidad}
                onChange={handleChange}
                className={inputCls}
                placeholder="Ciudad"
              />
            </div>

            <div>
              <label className={labelCls}>Teléfono</label>
              <input
                type="text"
                name="telefono"
                autoComplete="off"
                value={cliente.telefono}
                onChange={handleChange}
                className={inputCls}
                placeholder="Contacto"
              />
            </div>

            {/* Descripción Ordeñadora */}
            <div className="md:col-span-3">
              <label className={labelCls}>Descripción Ordeñadora <span className="text-red-500">*</span></label>
              <textarea
                name="descripcion_ordeniadora"
                autoComplete="off"
                value={cliente.descripcion_ordeniadora}
                onChange={handleChange}
                rows={3}
                className="w-full border border-slate-300 rounded-lg px-3 py-2 text-[13px] text-slate-900 bg-white outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all resize-none"
                placeholder="Ingresa los detalles técnicos aquí..."
                required
              />
            </div>
          </div>

          {/* Botón Guardar */}
          <div className="flex justify-end pt-3 mt-1 border-t border-slate-100">
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full md:w-48 h-9 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white rounded-lg font-bold text-[13px] shadow-sm transition-all active:scale-[0.98] flex items-center justify-center gap-2"
            >
              <Save size={15} />
              GUARDAR
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
